import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import InfoIcon from '../icons/InfoIcon';
import alertaStyles from './Alerta.styles';
import { salesChannelIs99food } from '../../../utils/check-sales-channel';

const useStyles = makeStyles((theme) => ({
  alertBoxNf: {
    ...alertaStyles.alertBox,
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    backgroundColor: '#E1F9FF',
    gap: '1rem',
  },
  alertTitle: {
    ...alertaStyles.alertTitle,
    fontSize: '18px',
    fontStyle: 'normal',
  },
  alertSubtitle: {
    ...alertaStyles.alertSubtitle,
    fontSize: '16px',
    
  }
}));

function AlertaDeInformacao({ title, body }) {
  const classes = useStyles();

  return (
    <Box className={classes.alertBoxNf}>
      <InfoIcon />
      <Box display={'flex'} flexDirection={'column'} flex={1}>
        <Typography variant="inherit" className={classes.alertTitle}>
          {title}
        </Typography>
        <Typography variant="caption" className={classes.alertSubtitle}>
          {body}
        </Typography>
      </Box>
    </Box>
  )
}

export default AlertaDeInformacao;